import { t } from 'i18next';
import { RegisterOptions } from 'react-hook-form';
import { DamScheduleFormValues } from './types';

const weekDaysList = {
  mon: t('diasDaSemana.seg'),
  tue: t('diasDaSemana.ter'),
  wed: t('diasDaSemana.qua'),
  thu: t('diasDaSemana.qui'),
  fri: t('diasDaSemana.sex'),
  sat: t('diasDaSemana.sab'),
  sun: t('diasDaSemana.dom'),
};

export const weekDays = Object.entries(weekDaysList)
  .map(([day, name]) => ({
    name,
    day: day as keyof typeof weekDaysList,
    checked: false,
  }));

export const DEFAULT_FORM_VALUES : DamScheduleFormValues = {
  endTime: '',
  exceptionDate: '',
  fullDay: false,
  permission: 'allow',
  startTime: '',
  weekDays: [],
};

export const FORM_VALIDATORS: Record<keyof DamScheduleFormValues, RegisterOptions<DamScheduleFormValues>> = {
  endTime: {
    required: t('obrigatorio'),
    validate: (value, formValues) => {
      if (!value || !formValues.startTime) return true;
      return value > formValues.startTime || t('horarioFinalMaiorInicial');
    },
  },
  startTime: {
    required: t('obrigatorio'),
    validate: (value, formValues) => {
      if (!value || !formValues.endTime) return true;
      return value < formValues.endTime || t('horarioInicialMenorFinal');
    },
  },
  exceptionDate: {
    required: false,
    validate: (value) => {
      const [day, month, year] = (value as string).split('/').map(Number);
      const date = new Date(year, month - 1, day);
      const isValidDate = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
      if (!isValidDate) return t('dataInvalida');

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date >= today || t('dataDeveSerFutura');
    },
  },
  fullDay: {
    required: false,
  },
  permission: {
    required: true,
  },
  weekDays: {
    validate: (value) => (value as string[]).length > 0 || t('selecioneAoMenosUmDia'),
  },

};
